import { Component } from 'react'

import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

class ScrollToTop extends Component {
  componentDidUpdate(prevProps): any {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'location' does not exist on type 'Readon... Remove this comment to see the full error message
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0)
    }
  }

  render(): any {
    return this.props.children
  }
}

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof ScrollToTop' is not assig... Remove this comment to see the full error message
export default withRouter(ScrollToTop)

// @ts-expect-error ts-migrate(2339) FIXME: Property 'propTypes' does not exist on type 'typeo... Remove this comment to see the full error message
ScrollToTop.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
}
